// extracted by mini-css-extract-plugin
module.exports = {"YHPreApplyChoose":"index-module_YHPreApplyChoose_1yCUP","title":"index-module_title_OqBpj"};